import { useState } from "react"
import { Modal, Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Slider from "@mui/material/Slider"
import NameLabel from "../nameLabel"
import QRGenerator from "../generateQrCode"
import { RgbToHex } from "../displayColor"

interface NameOrNumberModalProps {
  showNameSize: boolean
  nameSize: number
  setNameSize: (value: any) => void
  onHide: () => void
  selectedFont: any
  selectedColorName: string
  onConfirm: () => void
  namePosition: { x: number; y: number }
  setNamePosition: (value: any) => void
  uploadedImageRef: React.RefObject<HTMLImageElement>
  nameDivRef: React.RefObject<HTMLDivElement>
}

export const NameOrNumberSizeModal = ({
  showNameSize,
  onHide,
  selectedFont,
  nameSize,
  setNameSize,
  selectedColorName,
  // onSizeChange,
  setNamePosition,
  onConfirm,
  namePosition,
  uploadedImageRef,
  nameDivRef,
}: NameOrNumberModalProps) => {
  const { t } = useTranslation()
  const handleSliderChange = (_event: Event, newValue: number | number[]) => {
    if (typeof newValue === "number") {
      const newSize = newValue * 1 // Adjust the multiplier if needed
      setNameSize(newSize)

      if (uploadedImageRef?.current && nameDivRef?.current) {
        const parentRect = uploadedImageRef.current.getBoundingClientRect()
        const qrRect = nameDivRef.current.getBoundingClientRect()

        // Revalidate position to ensure the QR code is within bounds
        const newX = Math.min(
          Math.max(namePosition.x, 1),
          parentRect.width - newSize - 80,
        )
        const newY = Math.min(
          Math.max(namePosition.y, 1),
          parentRect.height - newSize - 80,
        )

        // Update position after resizing
        setNamePosition({ x: newX, y: newY })
      }
    }
  }
  return (
    <Modal show={showNameSize} onHide={onHide} centered>
      <Modal.Body className="p-5 d-flex flex-column justify-content-center align-items-center gap-2">
        <div
          style={{
            width: "300px",
            height: "250px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <h5 className="mb-4 mt-1  text-center">
            {t("invitation.changeNameOrNumberSize")}
          </h5>

          <div className="d-flex flex-column">
            <div
              style={{
                height: "auto",
                width: "auto",
              }}
              onClick={() => onHide()}
            >
              <NameLabel
                label={t("invitation.nameOrNumber")}
                color={RgbToHex(selectedColorName)}
                size={nameSize}
                font={selectedFont?.fontFamily}
              />
            </div>
          </div>

          <Slider
            defaultValue={16}
            min={10}
            max={30}
            step={1}
            value={nameSize}
            // onChange={(event, value) => onSizeChange(value)}
            onChange={handleSliderChange}
            aria-label="Default"
            valueLabelDisplay="auto"
          />

          <Button className="mt-3 mb-2" onClick={onConfirm}>
            {t("buttons.update")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}
